import { useEffect, useState } from 'react';
import ViewControl from '../../ModelControls/ViewControl';
import store from '../../../redux/store';
import { useSelector } from "react-redux";



export function TestModel(props) {
  const { solution, material, modelView } = props;

  const [materialUrl, setMaterialUrl] = useState(localStorage.getItem('materialUrl'))
  const [sidesMaterial, setsidesMaterial] = useState(localStorage.getItem('sidesMaterial'))
  const [windowMaterial, setwindowMaterial] = useState(localStorage.getItem('windowMaterial'))
  const [roofMaterial, setroofMaterial] = useState(localStorage.getItem('roofMaterial'))



  const state = store.getState()
  const viewControlsState = useSelector(state => state.viewControls);

  const [view, setView] = useState(viewControlsState.modelView === 'external' ? 'ext' : 'int')


  useEffect(() => {
    // debugger;
    // console.log(materialUrl)
    setView(viewControlsState.modelView === 'external' ? 'ext' : 'int'); // passed from UI
    // setMaterialUrl(localStorage.getItem('materialUrl'))

    setsidesMaterial(localStorage.getItem('sidesMaterial'))
    setwindowMaterial(localStorage.getItem('windowMaterial'))
    setroofMaterial(localStorage.getItem('roofMaterial'))

    const colors = {
      // { "10": "#00BFFF" },
      "lift": "#DCDCDC",
      "6": "#F08080"
    }

    const topRoughnessValue = 0.7;
    const roughnessValue = 0.8;

    const element = document.querySelector("#myScene");
    if (element) {
      const elements = element.getElementsByTagName('a-box');
      while (elements[0]) {
        elements[0].parentNode.removeChild(elements[0]);
      }

      for (const building of solution.buildings) {
        for (const floor of building.floors) {
          for (const wing of floor.wings) {
            for (const location of wing.locations) {
              for (const unit of location.units) {
                let cube = document.createElement("a-box");
                if (unit.unit_name.substring(0, 4) === 'plot') {
                  cube.setAttribute("position", `${unit.y / 15} ${unit.z / 15} ${(unit.x - 30) / 15}`);
                  cube.setAttribute("scale", `${unit.d / 15} ${unit.h / 15} ${unit.w / 15}`);
                  if (view === 'ext') {
                    let resultW = Math.ceil(unit.w / 2);
                    let resultD = Math.ceil(unit.d / 2);
                    cube.setAttribute("material", `src:#ground; roughness: 0.7; repeat: ${resultD} ${resultW}`);
                    cube.setAttribute("shadow", `receive: true`);
                    cube.setAttribute("shadow", `cast: false`);
                  }
                  else {
                    // debugger;
                    // cube.setAttribute("color", "#FFFFFF");
                  }
                  element.append(cube);
                }
                else if (unit.unit_name.substring(0, 4) === 'roof' && view === 'ext') {
                  cube.setAttribute("position", `${unit.y / 15} ${unit.z / 15} ${(unit.x - 30) / 15}`);
                  cube.setAttribute("scale", `${unit.d / 15} ${unit.h / 15} ${unit.w / 15}`);
                  let resultW = Math.ceil(unit.w / 2);
                  let resultD = Math.ceil(unit.d / 2);
                  cube.setAttribute("material", `src: #top; roughness: ${topRoughnessValue}; repeat: ${resultD} ${resultW}`);
                  cube.setAttribute("shadow", `cast: false`);
                  element.append(cube);
                }
                else {
                  let wallResultW;
                  let wallResultD;
                  if (view === 'ext') {
                    cube.setAttribute("position", `${unit.y / 15} ${unit.z / 15} ${((unit.x - 30) / 15)}`);
                    cube.setAttribute("scale", `${unit.d / 15} ${unit.h / 15} ${unit.w / 15}`);
                    if (unit.unit_name === 'corridor') {
                      wallResultW = 0.5;
                      wallResultD = Math.ceil(unit.h / 5);
                    }
                    else {
                      wallResultW = 1;
                      wallResultD = 1;
                    }
                    cube.setAttribute("material", `src:#sides; repeat: ${wallResultW} ${wallResultD}; normal-map:#sides_nm; normal-texture-repeat:${wallResultW} ${wallResultD}; roughness: ${roughnessValue}`);
                    cube.setAttribute("shadow", `cast: true`);
                    element.append(cube);
                    if (unit.windows) {
                      for (const window of unit.windows) {
                        let win = document.createElement("a-box");
                        win.setAttribute("position", `${window.yw / 15} ${window.zw / 15} ${(window.xw - 30) / 15}`);
                        win.setAttribute("scale", `${window.dw / 15} ${window.hw / 15} ${window.ww / 15}`);
                        win.setAttribute("material", `src:#window; normal-map:#window_nm; roughness: 0.2`);
                        element.append(win);
                      }
                    }
                  }
                  else { //if 'view' is internal
                    if (unit.unit_name.substring(0, 4) !== 'roof') {
                      cube.setAttribute("position", `${unit.y / 15} ${unit.z / 15} ${((unit.x - 30) / 15)}`);
                      cube.setAttribute("scale", `${unit.d / 15} ${unit.h / 15} ${unit.w / 15}`);
                      const color = colors[unit.unit_name];
                      if (color) {
                        cube.setAttribute("color", color);
                        cube.setAttribute("opacity", 0.5);
                      }
                      else {
                        let color = unit.color ? unit.color : 'white'; // unit.hexa_color ? '#' + unit.hexa_color : 'white';
                        cube.setAttribute("color", color);
                        cube.setAttribute("opacity", 0.5);
                      }
                      element.append(cube);
                    }
                  }
                }
              }

            }
          }
        }
      }
    } else {

    }


  }, [solution, view, modelView, state.viewControls.modelView, viewControlsState]);

  return (
    <>
      <a-scene id='myScene' vr-mode-ui="enabled: false" embedded>
        <a-entity
          camera="active: true; zoom: 1; fov: 80; far: 10000; near: 0.5;"
          look-controls
          orbit-controls="target: 3 0 1; minDistance: 0.5; maxDistance: 180; initialPosition: 5 3 5"
        ></a-entity>


        {/* Sky */}
        <a-sky src="#sky">
        </a-sky>

        {/* <!-- Light --> */}
        <a-entity
          light="type: directional;
          color: #FFFFFF;
          intensity: 0.8;
          shadowCameraLeft: -100;
          shadowCameraRight: 100;
          castShadow: true;
          shadowMapHeight: 15000;
          shadowMapWidth: 15000"
          position="-4.5 4.5 3"></a-entity>

        <a-light type="ambient" color="#FFF" intensity="0.8" ></a-light>

        {/* Ground */}
        <a-plane material="color: #FFA532;
		  side: front;	  
		  roughness: 0.6"
          rotation="-90 0 0"
          position="0 -0.0 0"
          shadow="receive: true"
          scale="100 100 1">
        </a-plane>

        <a-plane material="color: #CD853F;
		  side: back;	  
		  roughness: 0.7"
          rotation="-90 0 0"
          position="0 -0.15 0"
          scale="100 100 1">
        </a-plane >

        <a-assets>
          {/* <img id="pavement" alt='pavement' src="textures/paving.jpg" /> */}
          <img id="sky" alt='sky' src="textures/sky.jpg" />

          {/* Cube textures*/}
          {/* For 'external' view*/}
          <img id="sides" alt='sides' src={`textures/EW/${sidesMaterial}.jpg`} /> {/* passed from UI*/}
          <img id="sides_nm" src={`textures/EW/${sidesMaterial}NM.png`} /> {/*passed from UI */}

          {/* For 'windows (WNDW)' */}
          <img id="window" src="textures/WNDW/WN1.jpg" />  {/*passed from UI */}
          <img id="window_nm" src="textures/WNDW/WN1NM.png" /> {/*passed from UI */}

          {/* <img id="sides" src="textures/EW/EW3.jpg" /> passed from UI */}


          {/* For 'external' view*/} {/* passed from UI or BackEnd*/}
          <script id="colors" type="application/json">
          </script>


          {/* <!-- For 'roof (RF)'--> */}
          <img id="top" src={`textures/RF/${roofMaterial}.jpg`} /> {/* passed from UI or BackEnd*/}

          {/* <!-- For 'ground (GRND)'--> */}
          <img id="ground" src="textures/GRND/gravel.jpg" /> {/*<!-- NOT passed from UI - this is constant--> */}





        </a-assets>

      </a-scene>


      <ViewControl />
    </>
  )
}
